<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header
                    :menu-listing="menuListing"
                    @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import request from '@/utils/request'

    export default {
        components: {},

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */

        props: {}, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                menuListing: [
                    {
                        anchorLink: '/developers/api-logs',
                        menuLabel: 'API Logs',
                        name: 'view-api-logs',
                        permission: ['manage-api-logs'],
                    },
                    {
                        anchorLink: '/developers/webhooks',
                        menuLabel: 'Webhooks',
                        name: 'view-webhooks',
                        permission: ['manage-webhooks'],
                    },
                    {
                        anchorLink: '/developers/application-access',
                        menuLabel: 'Application Access',
                        name: 'view-application-access',
                        permission: ['manage-application-access'],
                    },
                ],
            }
        }, // End of Component > data

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters([
                'dataSegmentId',
            ]),
        }, // End of Component > methods

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        mounted() {}, // End of Component > computed

        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {}, // End of Component > mounted
    } // End of export default
</script>
